import { useRef } from 'react';

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';

import { RunReconciliationDialogProps } from './types';

/**
 * @description Says what a deduction reconciliation checks, for the companies in scope.
 */
const describeDeductionRun = (scope: string) =>
  `Check the deduction aggregates of ${scope} against the ledger now? It runs in the background and appears in the list once it starts.`;

/** Asks an admin to confirm before a reconciliation of every company, or of one company, is queued. */
function RunReconciliationDialog({
  isOpen,
  isQueueing,
  companyName,
  description = describeDeductionRun,
  onClose,
  onConfirm,
}: RunReconciliationDialogProps) {
  const cancelRef = useRef<HTMLButtonElement>(null);
  const scope = companyName || 'every company';

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      closeOnOverlayClick={!isQueueing}
      closeOnEsc={!isQueueing}
    >
      <AlertDialogOverlay>
        <AlertDialogContent data-testid="run-reconciliation-dialog">
          <AlertDialogHeader>Run reconciliation</AlertDialogHeader>
          <AlertDialogBody>{description(scope)}</AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              variant="outline"
              onClick={onClose}
              isDisabled={isQueueing}
              data-testid="cancel-run-reconciliation-button"
            >
              Cancel
            </Button>
            <Button
              ml="12px"
              onClick={onConfirm}
              isLoading={isQueueing}
              data-testid="confirm-run-reconciliation-button"
            >
              Run now
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export default RunReconciliationDialog;
